import { z } from 'zod';
import { VoucherBookSchema } from './document-type.js';
// Summary of a VoucherBook's live counter state. `totalUsed` is the sum of
// `current` across all year/month buckets; `latestYear`/`latestMonth` describe
// the most recent bucket so the UI can label "next number" context. Both
// `latestYear` and `latestMonth` are null when no counter rows exist yet for
// the book (newborn books only get a row once the first JV is emitted).
export const VoucherCounterSummarySchema = z.object({
    totalUsed: z.number().int().nonnegative(),
    latestYear: z.number().int().nullable(),
    latestMonth: z.number().int().nullable(),
});
// Wire shape returned by GET /companies/:companyId/document-types/:typeId/books
// — additive extension of VoucherBookSchema so consumers that only need the
// raw book can keep using VoucherBookSchema.
export const VoucherBookWithCounterSchema = VoucherBookSchema.extend({
    counter: VoucherCounterSummarySchema,
});
//# sourceMappingURL=voucher-counter.js.map